export default {
      id: "common__jet_ski-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__jet_ski",
      toString: function () {
        return this.url;
      }
    }